import { Input } from "@/components/kit";
import {
  FieldContent,
  FieldLabel,
  Field as FieldLayout,
} from "@/components/ui/field";
import { useEffect, useRef, useState } from "react";

type SuggestTextFieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (next: string) => void;
  options: Array<{ value: string; count: number }>;
  placeholder?: string;
  disabled?: boolean;
};

export function SuggestTextField({
  id,
  label,
  value,
  onChange,
  options,
  placeholder,
  disabled,
}: SuggestTextFieldProps) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onPointerDown(event: PointerEvent) {
      if (!rootRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("pointerdown", onPointerDown);
    return () => document.removeEventListener("pointerdown", onPointerDown);
  }, []);

  const showList = open && !disabled && options.length > 0;

  return (
    <FieldLayout>
      <FieldLabel htmlFor={id}>{label}</FieldLabel>
      <FieldContent>
        <div ref={rootRef} className="relative">
          <Input
            id={id}
            value={value}
            disabled={disabled}
            placeholder={placeholder}
            autoComplete="off"
            onChange={(e) => {
              onChange(e.target.value);
              setOpen(true);
            }}
            onFocus={() => setOpen(true)}
          />
          {showList ? (
            <div className="absolute z-20 mt-1 max-h-48 w-full overflow-auto rounded-xl border border-secondary/20 bg-card p-1 shadow-md">
              {options.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  className="flex w-full items-center justify-between gap-2 rounded-lg px-3 py-2 text-left text-sm transition-colors hover:bg-secondary/10"
                  onClick={() => {
                    onChange(opt.value);
                    setOpen(false);
                  }}
                >
                  <span className="truncate font-medium">{opt.value}</span>
                  <span className="shrink-0 text-muted-foreground text-xs tabular-nums">
                    {opt.count}
                  </span>
                </button>
              ))}
            </div>
          ) : null}
        </div>
      </FieldContent>
    </FieldLayout>
  );
}
